import cabecera from "./bloques/cabecera";
import desplegables from "./bloques/desplegables";
import lineaDeTiempo from "./bloques/linea_de_tiempo";
import testimonios from "./bloques/testimonios";
import imagenes from "./bloques/imagenes";
import videos from "./bloques/videos";
const bloques = () => {
    cabecera();
    desplegables();
    lineaDeTiempo();
    testimonios();
    imagenes();
    videos();
};
export default bloques;
